import axios from 'axios';
import VueRouter from 'vue-router';


const BASE = 'http://api.azcall.az/';


var token; 

export async function Login() {
    try {
        const response = await axios.post(
            "http://api.azcall.az/api/auth/login",
            this.user,
            {
                headers: {

                },
            }
        );
        this.token = response.data.message;
        localStorage.setItem('token', response.data.message);
        localStorage.setItem('charts-period', "2");
        token = response.data.message;
        this.$router.push('dashboard');
        console.log(token);
    } catch (error) {
        console.log(error);
    }
}

export async function Logout() {
    try { 
        localStorage.removeItem('token');
        localStorage.removeItem('charts-period');
        this.$router.push('login');
    } catch (error) {
        console.log(error);
    }
}

export function TopOperatorGet() {
    return axios.get(
            "http://api.azcall.az/api/v1/cdr/top-operator/"+localStorage.getItem("charts-period"),
            {
                headers: {
                    "Authorization":`Bearer ${localStorage.getItem('token')}`
                },
            }
        ).then(res=>res.data)
        .catch(err=>console.log(err))
}

export function OverallStatisticsGet(filter,pagination) {
    return axios.get(
            "http://api.azcall.az/api/v1/cdr/overall-statistics",
            {
                headers: {
                    "Authorization":`Bearer ${localStorage.getItem('token')}`
                },
                params:{
                    FromDate:filter.FromDate,
                    ToDate:filter.ToDate,
                    Src:filter.Src,
                    Dst:filter.Dst,
                    PageNumber:pagination.PageNumber,
                    PageSize:pagination.PageSize
                }
            }
        ).then(res=>res.data)
        .catch(err=>console.log(err))
}

export function OverallCallCountGet() {
    return axios.get(
            "http://api.azcall.az/api/v1/cdr/overall-call-count/"+localStorage.getItem("charts-period"),
            {
                headers: {
                    "Authorization":`Bearer ${localStorage.getItem('token')}`
                },
            }
        ).then(res=>res.data)
        .catch(err=>console.log(err))
}

export function OverallCallDurationGet() {
    return axios.get(
            "http://api.azcall.az/api/v1/cdr/overall-call-duration/" + localStorage.getItem("charts-period"),
            {
                headers: {
                    "Authorization":`Bearer ${localStorage.getItem('token')}`
                },
            }
        ).then(res=>res.data)
        .catch(err=>console.log(err))
}

export async function Register() {

    try {
        const response = await axios.post(
            "http://api.azcall.az/api/auth/register",
            this.newUser,
            {
                headers: {

                },
            }
        );
        this.token = response.data.message;
        console.log(this.token);
    } catch (error) {
        console.log(error);
    }
}

